export default "__VITE_ASSET__afYr1dr___"